import { render } from "./TipoDocumentoCrearActualizarComponent.vue?vue&type=template&id=996a38a2"
import script from "./TipoDocumentoCrearActualizarComponent.vue?vue&type=script&lang=js"
export * from "./TipoDocumentoCrearActualizarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__